import { assessmentList, courseAssessmentList, assessmentArtifactList, coursePublishedAssessmentList } from "constants/assessment";

const initialState = {
  assessmentList: {},
  courseAssessmentList: {},
  assessmentArtifactList: {},
  coursePublishedAssessmentList: {},
};

const assessment = (state = initialState, action) => {
  switch (action.type) {
    case assessmentList:
      return { ...state, assessmentList: action.payload };
    case courseAssessmentList:
      return { ...state, courseAssessmentList: action.payload };
    case assessmentArtifactList:
      return { ...state, assessmentArtifactList: action.payload };
    case coursePublishedAssessmentList:
      return { ...state, coursePublishedAssessmentList: action.payload };
    default:
      return state;
  }
};

export default assessment;